import { useQuery, UseQueryResult } from 'react-query';
import { API_USERS_ONLINE } from '../../utils/api/constants';
import { UserPublic } from '../../types/user';
import api from '../../utils/api/api';

const fetchLastConnectedMembers = async (): Promise<UserPublic[]> => {
  return api.get(API_USERS_ONLINE).then(res => res.data);
};

export const useLastConnectedMembers = (): UseQueryResult<UserPublic[], Error> => {
  return useQuery('lastConnectedMembers', fetchLastConnectedMembers, {
    refetchInterval: 900000, // 15 minutes
  });
};
